import axiosInstance from '../mainService';

const gudangService = {
    getGudang(search, page, limit, company_id) {
        const sanitizedSearch = search && search.trim() !== '' ? search : 'all';
        return axiosInstance.get(`/data/m154_gudang/name/${sanitizedSearch}/${page}/${limit}/${company_id}`).then(response => {
            return {
                data: response.data,
                headers: response.headers, // Total data dari header
            };
        });
    },
    totalAllGudang(search, company_id) {
        const sanitizedSearch = search && search.trim() !== '' ? search : 'all';
        return axiosInstance.get(`/count-data/m154_gudang/name/${sanitizedSearch}/${company_id}`).then(response => {
            return {
                data: response.data,
                headers: response.headers, // Total data dari header
            };
        });
    },
    addGudang(data) {
        return axiosInstance.post('/upload-data-dc', data);
    },
    updateGudang(data) {
        return axiosInstance.put(`/update-data/m154_gudang/${data.id}`, data);
    },
    deleteGudang(id, dc) {
        return axiosInstance.delete(`/delete-dc/${id}/${dc}`);
    },
};

export default gudangService;